// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisitCode-module__font-s-10___d2ukB {
  font-size: 10px !important;
}

.VisitCode-module__font-s-12___S8jlP {
  font-size: 12px !important;
}

.VisitCode-module__font-s-13___ILtDg {
  font-size: 13px !important;
}

.VisitCode-module__font-s-14___uaaPx {
  font-size: 14px !important;
}

.VisitCode-module__font-s-15___ihn3b {
  font-size: 15px !important;
}

.VisitCode-module__font-s-16___onQD4 {
  font-size: 16px !important;
}

.VisitCode-module__font-s-18___UXhhF {
  font-size: 18px !important;
}

.VisitCode-module__font-s-20___eidMV {
  font-size: 20px !important;
}

.VisitCode-module__font-s-22___sbx14 {
  font-size: 22px !important;
}

.VisitCode-module__font-s-28___owpYu {
  font-size: 28px !important;
}

.VisitCode-module__font-w-400___nc_pJ {
  font-weight: 400 !important;
}

.VisitCode-module__font-w-500___IG6r1 {
  font-weight: 500 !important;
}

.VisitCode-module__font-w-600___GWjgs {
  font-weight: 600 !important;
}

.VisitCode-module__font-w-700___v1rmP {
  font-weight: 700 !important;
}

.VisitCode-module__p-5___yNiOD {
  padding: 5px !important;
}

.VisitCode-module__p-12___DgcmU {
  padding: 12px !important;
}

.VisitCode-module__p-16___XFMWT {
  padding: 16px !important;
}

.VisitCode-module__p-30___HAZSK {
  padding: 30px !important;
}

.VisitCode-module__p-b-0___iyd2X {
  padding-bottom: 0 !important;
}

.VisitCode-module__p-b-5___yB5dL {
  padding-bottom: 5px !important;
}

.VisitCode-module__p-b-10___xU0hE {
  padding-bottom: 10px !important;
}

.VisitCode-module__p-b-12___PrLxI {
  padding-bottom: 12px !important;
}

.VisitCode-module__p-b-16___jOJnh {
  padding-bottom: 16px !important;
}

.VisitCode-module__p-b-18___iZ3mb {
  padding-bottom: 18px !important;
}

.VisitCode-module__p-b-20___NdJjo {
  padding-bottom: 20px !important;
}

.VisitCode-module__p-b-25___hn5d6 {
  padding-bottom: 25px !important;
}

.VisitCode-module__p-b-30___YBWT_ {
  padding-bottom: 30px !important;
}

.VisitCode-module__p-b-50___myuF4 {
  padding-bottom: 50px !important;
}

.VisitCode-module__p-t-0___SeyDT {
  padding-top: 0 !important;
}

.VisitCode-module__p-t-12___V57rU {
  padding-top: 12px !important;
}

.VisitCode-module__p-t-16___aHNob {
  padding-top: 16px !important;
}

.VisitCode-module__p-t-18___CueOs {
  padding-top: 18px !important;
}

.VisitCode-module__p-t-20___Ih6Qe {
  padding-top: 20px !important;
}

.VisitCode-module__p-t-30___FXr8l {
  padding-top: 30px !important;
}

.VisitCode-module__p-t-40___PUxIF {
  padding-top: 40px !important;
}

.VisitCode-module__p-t-50___nz_tH {
  padding-top: 50px !important;
}

.VisitCode-module__p-l-20___Xjm4I {
  padding-left: 20px !important;
}

.VisitCode-module__p-l-30___xi_F7 {
  padding-left: 30px !important;
}

.VisitCode-module__p-l-40___yFvj9 {
  padding-left: 40px !important;
}

.VisitCode-module__p-r-16___hquQ0 {
  padding-right: 16px !important;
}

.VisitCode-module__p-r-20___F647v {
  padding-right: 20px !important;
}

.VisitCode-module__p-r-30____d6NT {
  padding-right: 30px !important;
}

.VisitCode-module__p-r-50___ARsIx {
  padding-right: 50px !important;
}

.VisitCode-module__p-r-60___HzySu {
  padding-right: 60px !important;
}

.VisitCode-module__m-b-1___uYFAd {
  margin-bottom: 1px !important;
}

.VisitCode-module__m-b-2___MO2mG {
  margin-bottom: 2px !important;
}

.VisitCode-module__m-b-6___Zpx62 {
  margin-bottom: 6px !important;
}

.VisitCode-module__m-b-8___VL1HA {
  margin-bottom: 8px !important;
}

.VisitCode-module__m-b-10___qKZEW {
  margin-bottom: 10px !important;
}

.VisitCode-module__m-b-14___fzk5e {
  margin-bottom: 14px !important;
}

.VisitCode-module__m-b-16___DKYp0 {
  margin-bottom: 16px !important;
}

.VisitCode-module__m-b-20___XKCIA {
  margin-bottom: 20px !important;
}

.VisitCode-module__m-b-22___G3OiP {
  margin-bottom: 22px !important;
}

.VisitCode-module__m-b-24___M2ZFo {
  margin-bottom: 24px !important;
}

.VisitCode-module__m-b-30___JfLnM {
  margin-bottom: 30px !important;
}

.VisitCode-module__m-b-32___Pxq0b {
  margin-bottom: 32px !important;
}

.VisitCode-module__m-b-40___GGx7Q {
  margin-bottom: 40px !important;
}

.VisitCode-module__m-t-2___PZD1u {
  margin-top: 2px !important;
}

.VisitCode-module__m-t-3___OqjKv {
  margin-top: 3px !important;
}

.VisitCode-module__m-t-4___O3RWa {
  margin-top: 4px !important;
}

.VisitCode-module__m-t-5___hxC82 {
  margin-top: 5px !important;
}

.VisitCode-module__m-t-8___OiHB3 {
  margin-top: 8px !important;
}

.VisitCode-module__m-t-10___eO3J_ {
  margin-top: 10px !important;
}

.VisitCode-module__m-t-15___ua4AO {
  margin-top: 15px !important;
}

.VisitCode-module__m-t-16___FWalx {
  margin-top: 16px !important;
}

.VisitCode-module__m-t-20___yKrI4 {
  margin-top: 20px !important;
}

.VisitCode-module__m-t-22___Wxi6K {
  margin-top: 22px !important;
}

.VisitCode-module__m-t-30___TKRka {
  margin-top: 30px !important;
}

.VisitCode-module__m-t-32___oVURR {
  margin-top: 32px !important;
}

.VisitCode-module__m-l-auto___gtKZs {
  margin-left: auto !important;
}

.VisitCode-module__m-l-4___De4kN {
  margin-left: 4px !important;
}

.VisitCode-module__m-l-5____VB2_ {
  margin-left: 5px !important;
}

.VisitCode-module__m-l-6___C6mZP {
  margin-left: 6px !important;
}

.VisitCode-module__m-l-8___SIUz5 {
  margin-left: 8px !important;
}

.VisitCode-module__m-l-10___vS5EJ {
  margin-left: 10px !important;
}

.VisitCode-module__m-l-16___wxZ6w {
  margin-left: 16px !important;
}

.VisitCode-module__m-l-20___ECCj9 {
  margin-left: 20px !important;
}

.VisitCode-module__m-l-24___Mq0Fm {
  margin-left: 24px !important;
}

.VisitCode-module__m-l-30___GdOzf {
  margin-left: 30px !important;
}

.VisitCode-module__m-l-35___s1F9M {
  margin-left: 35px !important;
}

.VisitCode-module__m-l-40___NDONr {
  margin-left: 40px !important;
}

.VisitCode-module__m-r-8___ZydVc {
  margin-right: 8px !important;
}

.VisitCode-module__m-r-10___a9Ltq {
  margin-right: 10px !important;
}

.VisitCode-module__m-r-16___A94fW {
  margin-right: 16px !important;
}

.VisitCode-module__m-r-20___aA7ZA {
  margin-right: 20px !important;
}

.VisitCode-module__m-r-24___dXhNh {
  margin-right: 24px !important;
}

.VisitCode-module__m-r-30___GBOg4 {
  margin-right: 30px !important;
}

.VisitCode-module__m-r-40___EzZkM {
  margin-right: 40px !important;
}

.VisitCode-module__border-r-3___HHwK7 {
  border-radius: 3px !important;
}

.VisitCode-module__border-r-4___POzTq {
  border-radius: 4px !important;
}

.VisitCode-module__border-r-6___I14Nw {
  border-radius: 6px !important;
}

.VisitCode-module__border-r-10___zWsbF {
  border-radius: 10px !important;
}

.VisitCode-module__border-r-12___ZbY6i {
  border-radius: 12px !important;
}

.VisitCode-module__border-r-16___bDAtY {
  border-radius: 16px !important;
}

.VisitCode-module__border-r-50____B67m {
  border-radius: 50% !important;
}

.VisitCode-module__primary-border___edtq2 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCode-module__primary-border-b___iCaPb {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCode-module__primary-border-t___UKiSn {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCode-module__primary-border-l___xQCJz {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCode-module__primary-border-r___Oy9eJ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCode-module__secondary-border___r74St {
  border: 1px solid #637768;
}

.VisitCode-module__secondary-border-b___DFk8r {
  border-bottom: 1px solid #637768;
}

.VisitCode-module__secondary-border-t___DkF5Q {
  border-top: 1px solid #637768;
}

.VisitCode-module__secondary-border-l___D2INO {
  border-left: 1px solid #637768;
}

.VisitCode-module__secondary-border-r___vxeRe {
  border-right: 1px solid #637768;
}

.VisitCode-module__gap-0___XTLWP {
  gap: 0 !important;
}

.VisitCode-module__gap-2___ezqBL {
  gap: 2px !important;
}

.VisitCode-module__gap-4___gHt68 {
  gap: 4px !important;
}

.VisitCode-module__gap-5___NWwPI {
  gap: 5px !important;
}

.VisitCode-module__gap-6___uNd1p {
  gap: 6px !important;
}

.VisitCode-module__gap-8___NY3Wh {
  gap: 8px !important;
}

.VisitCode-module__gap-10___wnrHk {
  gap: 10px !important;
}

.VisitCode-module__gap-12___yhlkD {
  gap: 12px !important;
}

.VisitCode-module__gap-14___bLGdr {
  gap: 14px !important;
}

.VisitCode-module__gap-16___gGiR4 {
  gap: 16px !important;
}

.VisitCode-module__gap-18___M2lK0 {
  gap: 18px !important;
}

.VisitCode-module__gap-20___ljxZe {
  gap: 20px !important;
}

.VisitCode-module__gap-24___djPHP {
  gap: 24px !important;
}

.VisitCode-module__gap-26___Mw4Yb {
  gap: 26px !important;
}

.VisitCode-module__gap-30___E3c1m {
  gap: 30px !important;
}

.VisitCode-module__gap-32___au_B1 {
  gap: 32px !important;
}

.VisitCode-module__gap-40___Je2Gs {
  gap: 40px !important;
}

.VisitCode-module__gap-50___sz2U0 {
  gap: 50px !important;
}

.VisitCode-module__flex-1___JXaic {
  flex: 1;
}

.VisitCode-module__flex-none___F8fVU {
  flex: none !important;
}

.VisitCode-module__flex-column___wFnSO {
  display: flex;
  flex-direction: column !important;
}

.VisitCode-module__flex-row___k5zLl {
  display: flex;
  flex-direction: row !important;
}

.VisitCode-module__vertically-centered___Ldtg9 {
  display: flex;
  align-items: center !important;
}

.VisitCode-module__horizontally-centered____qSEw {
  display: flex;
  justify-content: center !important;
}

.VisitCode-module__horizontally-end___lUaGv {
  display: flex;
  justify-content: end !important;
}

.VisitCode-module__vertically-start___EkDU_ {
  display: flex;
  align-items: start !important;
}

.VisitCode-module__space-between___ZRLXK {
  display: flex;
  justify-content: space-between !important;
}

.VisitCode-module__flex-wrap___iYBTj {
  flex-wrap: wrap !important;
}

.VisitCode-module__height-100___NgXpd {
  height: 100%;
}

.VisitCode-module__width-50___MzHrk {
  width: 50% !important;
}

.VisitCode-module__width-100___Yp_eU {
  width: 100%;
}

.VisitCode-module__cursor-pointer___fWiID {
  cursor: pointer;
}

.VisitCode-module__cursor-not-allowed___SLRcJ {
  cursor: not-allowed !important;
}

.VisitCode-module__absolute-centered___qa4Nc {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.VisitCode-module__absolute___JG68a {
  position: absolute;
}

.VisitCode-module__relative___yHcwS {
  position: relative;
}

.VisitCode-module__fixed___SbbuP {
  position: fixed;
}

.VisitCode-module__visible___xAiTg {
  opacity: 1;
}

.VisitCode-module__invisible___fxkQg {
  opacity: 0;
}

.VisitCode-module__col-90___tCWkI {
  width: 90% !important;
}

.VisitCode-module__col-auto___tWnoG {
  width: auto !important;
}

.VisitCode-module__medical-tabs___djCgT {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.VisitCode-module__medical-table-new___dCQ5z {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VisitCode-module__medical-table-new___dCQ5z:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VisitCode-module__medical-table-new___dCQ5z::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VisitCode-module__medical-table-new___dCQ5z::-webkit-scrollbar-track {
  display: none;
}
.VisitCode-module__medical-table-new___dCQ5z.VisitCode-module__no-pagination___I6zvs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VisitCode-module__medical-table-new___dCQ5z.VisitCode-module__no-pagination___I6zvs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VisitCode-module__medical-table-new___dCQ5z.VisitCode-module__no-pagination___I6zvs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VisitCode-module__medical-table-new___dCQ5z.VisitCode-module__no-pagination___I6zvs::-webkit-scrollbar-track {
  display: none;
}

.VisitCode-module__medical-table-empty___LjWvF {
  padding: 14px 40px !important;
}

.VisitCode-module__icon-btn___S4IIX {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.VisitCode-module__search-icon___ES1aB {
  width: 24px;
  height: 24px;
  align-self: center;
}

.VisitCode-module__disable-select___OiwlN {
  user-select: none;
}

.VisitCode-module__break-word___jA1Z1 {
  word-break: break-word;
}

.VisitCode-module__popup-clear-btn___twxXn {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.VisitCode-module__scroll-m-b-20_____3Yp {
  scroll-margin-bottom: 20px;
}

.VisitCode-module__dot___uCOsA {
  display: inline-block;
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 50%;
}

.VisitCode-module__badge___DO2pt {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-family: "IBM Plex Mono", monospace;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.VisitCode-module__sizeSm___cHGfT {
  height: 20px;
  min-width: 20px;
  padding: 0 4px;
  font-size: 10px;
}

.VisitCode-module__sizeMd___oKYGF {
  height: 26px;
  min-width: 24px;
  padding: 0 4px;
  font-size: 11px;
}

.VisitCode-module__sizeLg___TuNLd {
  height: 28px;
  min-width: 28px;
  padding: 0 6px;
  font-size: 12px;
}

.VisitCode-module__corner___aMVJm {
  align-self: stretch;
  height: auto;
  padding: 0 10px;
  border-radius: 0;
  box-shadow: none;
}

.VisitCode-module__cornerCard___qYSjt {
  min-width: 68px;
  font-size: 15px;
}

.VisitCode-module__cornerPanel___VkxvA {
  min-width: 76px;
  font-size: 17px;
}

.VisitCode-module__followUp___I7y5S {
  background: #69945f;
}

.VisitCode-module__kindFollowUp___R2Gwj {
  background: #48813b;
}

.VisitCode-module__consultation___WpenP {
  background: #6687bd;
}

.VisitCode-module__kindConsultation___OzD9l {
  background: #4972b7;
}

.VisitCode-module__infusion___RDYBH {
  background: #8e7ab5;
}

.VisitCode-module__kindInfusion___IUZcJ {
  background: #8065b1;
}

.VisitCode-module__assessment___BOkhi {
  background: #3c9888;
}

.VisitCode-module__kindAssessment___EIyXm {
  background: #088272;
}

.VisitCode-module__carePlan___Gb_nz {
  background: #3c93ac;
}

.VisitCode-module__kindCarePlan___mefYc {
  background: #0b7d97;
}

.VisitCode-module__other___Vj8xj {
  background: #7e8791;
}

.VisitCode-module__kindOther___Z0C6f {
  background: #6b747e;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/VisitCode.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AAzpBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AA4pBF;;AAzpBA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,6EAAA;AA4pBF;;AAzpBA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA4pBF;;AAzpBA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA4pBF;;AAzpBA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA4pBF;;AAzpBA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA4pBF;;AAzpBA;EACE,eAAA;EACA,eAAA;AA4pBF;;AAzpBA;EACE,eAAA;EACA,eAAA;AA4pBF;;AAxpBE;EACE,mBAAA;AA2pBJ;;AAxpBE;EACE,mBAAA;AA2pBJ;;AAhqBE;EACE,mBAAA;AAmqBJ;;AAhqBE;EACE,mBAAA;AAmqBJ;;AAxqBE;EACE,mBAAA;AA2qBJ;;AAxqBE;EACE,mBAAA;AA2qBJ;;AAhrBE;EACE,mBAAA;AAmrBJ;;AAhrBE;EACE,mBAAA;AAmrBJ;;AAxrBE;EACE,mBAAA;AA2rBJ;;AAxrBE;EACE,mBAAA;AA2rBJ;;AAhsBE;EACE,mBAAA;AAmsBJ;;AAhsBE;EACE,mBAAA;AAmsBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'sass:map';\n@use 'sass:string';\n@use 'common-src/styles/global' as *;\n\n.dot {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  flex-shrink: 0;\n  border-radius: 50%;\n}\n\n.badge {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 700;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n\n.sizeSm {\n  height: 20px;\n  min-width: 20px;\n  padding: 0 4px;\n  font-size: 10px;\n}\n\n.sizeMd {\n  height: 26px;\n  min-width: 24px;\n  padding: 0 4px;\n  font-size: 11px;\n}\n\n.sizeLg {\n  height: 28px;\n  min-width: 28px;\n  padding: 0 6px;\n  font-size: 12px;\n}\n\n.corner {\n  align-self: stretch;\n  height: auto;\n  padding: 0 10px;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.cornerCard {\n  min-width: 68px;\n  font-size: 15px;\n}\n\n.cornerPanel {\n  min-width: 76px;\n  font-size: 17px;\n}\n\n@each $kind, $colors in $visit-kinds {\n  .#{$kind} {\n    background: map.get($colors, base);\n  }\n\n  .kind#{string.to-upper-case(string.slice($kind, 1, 1))}#{string.slice($kind, 2)} {\n    background: map.get($colors, strong);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `VisitCode-module__font-s-10___d2ukB`,
	"fontS12": `VisitCode-module__font-s-12___S8jlP`,
	"fontS13": `VisitCode-module__font-s-13___ILtDg`,
	"fontS14": `VisitCode-module__font-s-14___uaaPx`,
	"fontS15": `VisitCode-module__font-s-15___ihn3b`,
	"fontS16": `VisitCode-module__font-s-16___onQD4`,
	"fontS18": `VisitCode-module__font-s-18___UXhhF`,
	"fontS20": `VisitCode-module__font-s-20___eidMV`,
	"fontS22": `VisitCode-module__font-s-22___sbx14`,
	"fontS28": `VisitCode-module__font-s-28___owpYu`,
	"fontW400": `VisitCode-module__font-w-400___nc_pJ`,
	"fontW500": `VisitCode-module__font-w-500___IG6r1`,
	"fontW600": `VisitCode-module__font-w-600___GWjgs`,
	"fontW700": `VisitCode-module__font-w-700___v1rmP`,
	"p5": `VisitCode-module__p-5___yNiOD`,
	"p12": `VisitCode-module__p-12___DgcmU`,
	"p16": `VisitCode-module__p-16___XFMWT`,
	"p30": `VisitCode-module__p-30___HAZSK`,
	"pB0": `VisitCode-module__p-b-0___iyd2X`,
	"pB5": `VisitCode-module__p-b-5___yB5dL`,
	"pB10": `VisitCode-module__p-b-10___xU0hE`,
	"pB12": `VisitCode-module__p-b-12___PrLxI`,
	"pB16": `VisitCode-module__p-b-16___jOJnh`,
	"pB18": `VisitCode-module__p-b-18___iZ3mb`,
	"pB20": `VisitCode-module__p-b-20___NdJjo`,
	"pB25": `VisitCode-module__p-b-25___hn5d6`,
	"pB30": `VisitCode-module__p-b-30___YBWT_`,
	"pB50": `VisitCode-module__p-b-50___myuF4`,
	"pT0": `VisitCode-module__p-t-0___SeyDT`,
	"pT12": `VisitCode-module__p-t-12___V57rU`,
	"pT16": `VisitCode-module__p-t-16___aHNob`,
	"pT18": `VisitCode-module__p-t-18___CueOs`,
	"pT20": `VisitCode-module__p-t-20___Ih6Qe`,
	"pT30": `VisitCode-module__p-t-30___FXr8l`,
	"pT40": `VisitCode-module__p-t-40___PUxIF`,
	"pT50": `VisitCode-module__p-t-50___nz_tH`,
	"pL20": `VisitCode-module__p-l-20___Xjm4I`,
	"pL30": `VisitCode-module__p-l-30___xi_F7`,
	"pL40": `VisitCode-module__p-l-40___yFvj9`,
	"pR16": `VisitCode-module__p-r-16___hquQ0`,
	"pR20": `VisitCode-module__p-r-20___F647v`,
	"pR30": `VisitCode-module__p-r-30____d6NT`,
	"pR50": `VisitCode-module__p-r-50___ARsIx`,
	"pR60": `VisitCode-module__p-r-60___HzySu`,
	"mB1": `VisitCode-module__m-b-1___uYFAd`,
	"mB2": `VisitCode-module__m-b-2___MO2mG`,
	"mB6": `VisitCode-module__m-b-6___Zpx62`,
	"mB8": `VisitCode-module__m-b-8___VL1HA`,
	"mB10": `VisitCode-module__m-b-10___qKZEW`,
	"mB14": `VisitCode-module__m-b-14___fzk5e`,
	"mB16": `VisitCode-module__m-b-16___DKYp0`,
	"mB20": `VisitCode-module__m-b-20___XKCIA`,
	"mB22": `VisitCode-module__m-b-22___G3OiP`,
	"mB24": `VisitCode-module__m-b-24___M2ZFo`,
	"mB30": `VisitCode-module__m-b-30___JfLnM`,
	"mB32": `VisitCode-module__m-b-32___Pxq0b`,
	"mB40": `VisitCode-module__m-b-40___GGx7Q`,
	"mT2": `VisitCode-module__m-t-2___PZD1u`,
	"mT3": `VisitCode-module__m-t-3___OqjKv`,
	"mT4": `VisitCode-module__m-t-4___O3RWa`,
	"mT5": `VisitCode-module__m-t-5___hxC82`,
	"mT8": `VisitCode-module__m-t-8___OiHB3`,
	"mT10": `VisitCode-module__m-t-10___eO3J_`,
	"mT15": `VisitCode-module__m-t-15___ua4AO`,
	"mT16": `VisitCode-module__m-t-16___FWalx`,
	"mT20": `VisitCode-module__m-t-20___yKrI4`,
	"mT22": `VisitCode-module__m-t-22___Wxi6K`,
	"mT30": `VisitCode-module__m-t-30___TKRka`,
	"mT32": `VisitCode-module__m-t-32___oVURR`,
	"mLAuto": `VisitCode-module__m-l-auto___gtKZs`,
	"mL4": `VisitCode-module__m-l-4___De4kN`,
	"mL5": `VisitCode-module__m-l-5____VB2_`,
	"mL6": `VisitCode-module__m-l-6___C6mZP`,
	"mL8": `VisitCode-module__m-l-8___SIUz5`,
	"mL10": `VisitCode-module__m-l-10___vS5EJ`,
	"mL16": `VisitCode-module__m-l-16___wxZ6w`,
	"mL20": `VisitCode-module__m-l-20___ECCj9`,
	"mL24": `VisitCode-module__m-l-24___Mq0Fm`,
	"mL30": `VisitCode-module__m-l-30___GdOzf`,
	"mL35": `VisitCode-module__m-l-35___s1F9M`,
	"mL40": `VisitCode-module__m-l-40___NDONr`,
	"mR8": `VisitCode-module__m-r-8___ZydVc`,
	"mR10": `VisitCode-module__m-r-10___a9Ltq`,
	"mR16": `VisitCode-module__m-r-16___A94fW`,
	"mR20": `VisitCode-module__m-r-20___aA7ZA`,
	"mR24": `VisitCode-module__m-r-24___dXhNh`,
	"mR30": `VisitCode-module__m-r-30___GBOg4`,
	"mR40": `VisitCode-module__m-r-40___EzZkM`,
	"borderR3": `VisitCode-module__border-r-3___HHwK7`,
	"borderR4": `VisitCode-module__border-r-4___POzTq`,
	"borderR6": `VisitCode-module__border-r-6___I14Nw`,
	"borderR10": `VisitCode-module__border-r-10___zWsbF`,
	"borderR12": `VisitCode-module__border-r-12___ZbY6i`,
	"borderR16": `VisitCode-module__border-r-16___bDAtY`,
	"borderR50": `VisitCode-module__border-r-50____B67m`,
	"primaryBorder": `VisitCode-module__primary-border___edtq2`,
	"primaryBorderB": `VisitCode-module__primary-border-b___iCaPb`,
	"primaryBorderT": `VisitCode-module__primary-border-t___UKiSn`,
	"primaryBorderL": `VisitCode-module__primary-border-l___xQCJz`,
	"primaryBorderR": `VisitCode-module__primary-border-r___Oy9eJ`,
	"secondaryBorder": `VisitCode-module__secondary-border___r74St`,
	"secondaryBorderB": `VisitCode-module__secondary-border-b___DFk8r`,
	"secondaryBorderT": `VisitCode-module__secondary-border-t___DkF5Q`,
	"secondaryBorderL": `VisitCode-module__secondary-border-l___D2INO`,
	"secondaryBorderR": `VisitCode-module__secondary-border-r___vxeRe`,
	"gap0": `VisitCode-module__gap-0___XTLWP`,
	"gap2": `VisitCode-module__gap-2___ezqBL`,
	"gap4": `VisitCode-module__gap-4___gHt68`,
	"gap5": `VisitCode-module__gap-5___NWwPI`,
	"gap6": `VisitCode-module__gap-6___uNd1p`,
	"gap8": `VisitCode-module__gap-8___NY3Wh`,
	"gap10": `VisitCode-module__gap-10___wnrHk`,
	"gap12": `VisitCode-module__gap-12___yhlkD`,
	"gap14": `VisitCode-module__gap-14___bLGdr`,
	"gap16": `VisitCode-module__gap-16___gGiR4`,
	"gap18": `VisitCode-module__gap-18___M2lK0`,
	"gap20": `VisitCode-module__gap-20___ljxZe`,
	"gap24": `VisitCode-module__gap-24___djPHP`,
	"gap26": `VisitCode-module__gap-26___Mw4Yb`,
	"gap30": `VisitCode-module__gap-30___E3c1m`,
	"gap32": `VisitCode-module__gap-32___au_B1`,
	"gap40": `VisitCode-module__gap-40___Je2Gs`,
	"gap50": `VisitCode-module__gap-50___sz2U0`,
	"flex1": `VisitCode-module__flex-1___JXaic`,
	"flexNone": `VisitCode-module__flex-none___F8fVU`,
	"flexColumn": `VisitCode-module__flex-column___wFnSO`,
	"flexRow": `VisitCode-module__flex-row___k5zLl`,
	"verticallyCentered": `VisitCode-module__vertically-centered___Ldtg9`,
	"horizontallyCentered": `VisitCode-module__horizontally-centered____qSEw`,
	"horizontallyEnd": `VisitCode-module__horizontally-end___lUaGv`,
	"verticallyStart": `VisitCode-module__vertically-start___EkDU_`,
	"spaceBetween": `VisitCode-module__space-between___ZRLXK`,
	"flexWrap": `VisitCode-module__flex-wrap___iYBTj`,
	"height100": `VisitCode-module__height-100___NgXpd`,
	"width50": `VisitCode-module__width-50___MzHrk`,
	"width100": `VisitCode-module__width-100___Yp_eU`,
	"cursorPointer": `VisitCode-module__cursor-pointer___fWiID`,
	"cursorNotAllowed": `VisitCode-module__cursor-not-allowed___SLRcJ`,
	"absoluteCentered": `VisitCode-module__absolute-centered___qa4Nc`,
	"absolute": `VisitCode-module__absolute___JG68a`,
	"relative": `VisitCode-module__relative___yHcwS`,
	"fixed": `VisitCode-module__fixed___SbbuP`,
	"visible": `VisitCode-module__visible___xAiTg`,
	"invisible": `VisitCode-module__invisible___fxkQg`,
	"col90": `VisitCode-module__col-90___tCWkI`,
	"colAuto": `VisitCode-module__col-auto___tWnoG`,
	"medicalTabs": `VisitCode-module__medical-tabs___djCgT`,
	"medicalTableNew": `VisitCode-module__medical-table-new___dCQ5z`,
	"noPagination": `VisitCode-module__no-pagination___I6zvs`,
	"medicalTableEmpty": `VisitCode-module__medical-table-empty___LjWvF`,
	"iconBtn": `VisitCode-module__icon-btn___S4IIX`,
	"searchIcon": `VisitCode-module__search-icon___ES1aB`,
	"disableSelect": `VisitCode-module__disable-select___OiwlN`,
	"breakWord": `VisitCode-module__break-word___jA1Z1`,
	"popupClearBtn": `VisitCode-module__popup-clear-btn___twxXn`,
	"scrollMB20": `VisitCode-module__scroll-m-b-20_____3Yp`,
	"dot": `VisitCode-module__dot___uCOsA`,
	"badge": `VisitCode-module__badge___DO2pt`,
	"sizeSm": `VisitCode-module__sizeSm___cHGfT`,
	"sizeMd": `VisitCode-module__sizeMd___oKYGF`,
	"sizeLg": `VisitCode-module__sizeLg___TuNLd`,
	"corner": `VisitCode-module__corner___aMVJm`,
	"cornerCard": `VisitCode-module__cornerCard___qYSjt`,
	"cornerPanel": `VisitCode-module__cornerPanel___VkxvA`,
	"followUp": `VisitCode-module__followUp___I7y5S`,
	"kindFollowUp": `VisitCode-module__kindFollowUp___R2Gwj`,
	"consultation": `VisitCode-module__consultation___WpenP`,
	"kindConsultation": `VisitCode-module__kindConsultation___OzD9l`,
	"infusion": `VisitCode-module__infusion___RDYBH`,
	"kindInfusion": `VisitCode-module__kindInfusion___IUZcJ`,
	"assessment": `VisitCode-module__assessment___BOkhi`,
	"kindAssessment": `VisitCode-module__kindAssessment___EIyXm`,
	"carePlan": `VisitCode-module__carePlan___Gb_nz`,
	"kindCarePlan": `VisitCode-module__kindCarePlan___mefYc`,
	"other": `VisitCode-module__other___Vj8xj`,
	"kindOther": `VisitCode-module__kindOther___Z0C6f`
};
module.exports = ___CSS_LOADER_EXPORT___;
